























































import { Vue, Component, Prop } from "vue-property-decorator";
import { State, Action, Getter, namespace } from "vuex-class";

import { EffectivenessState } from "@/store/effectiveness/models/effectiveness.state";
import { Mutations } from "@/store/effectiveness/mutations";

import { Pokemon } from "@/core/models";

import VCard from "@/components/VCard.vue";
import PokeTypeBadge from "@/components/PokemonTypeBadge.vue";
import PokeTypeDetail from "@/components/PokemonTypeDetail.vue";

import damageLabel from "../filters/DamageLabel";

const effectivenessStore = namespace("effectiveness");

@Component({
  components: {
    VCard,
    PokeTypeBadge,
    PokeTypeDetail
  },
  filters: {
    damageLabel
  }
})
export default class PokemonCardContainer extends Vue {
  @Prop()
  pokemon!: Pokemon;

  @effectivenessStore.State((state: EffectivenessState) => state.ui.viewMode)
  viewMode!: "atk" | "def";

  @effectivenessStore.Getter
  defKeys!: string;

  @effectivenessStore.Getter
  atkKeys!: string;

  @effectivenessStore.Mutation(Mutations.SET_VIEW_MODE)
  changeViewMode!: Function;
}
